import { StaticPage } from './StaticPage'

const sections = [
  { id: 'scope', label: 'Uvod' },
  { id: 'accounts', label: 'Računi' },
  { id: 'acceptable-use', label: 'Dovoljena uporaba' },
  { id: 'user-content', label: 'Vsebina uporabnikov' },
  { id: 'moderation', label: 'Moderiranje' },
  { id: 'availability', label: 'Razpoložljivost' },
  { id: 'liability', label: 'Odgovornost' },
  { id: 'changes', label: 'Spremembe' },
  { id: 'law', label: 'Pravo in kontakt' },
]

export function TermsPage() {
  return (
    <StaticPage
      title="Pogoji uporabe"
      description="Pravila za uporabo Fukodroma, odgovornosti uporabnikov, objavo skupnostne vsebine, moderatorske posege in pravni okvir storitve."
      path="/terms"
      eyebrow="Legal"
      updatedLabel="Zadnja vsebinska posodobitev: april 2026"
      sections={sections}
    >
      <section id="scope">
        <h2>Uvod in področje uporabe</h2>
        <p>
          Ti pogoji urejajo uporabo spletne storitve Fukodrom, vključno z zemljevidom lokacij,
          uporabniškimi računi, skupnostnimi vsebinami, forumi in povezanimi funkcijami. Z uporabo
          storitve potrjujete, da boste Fukodrom uporabljali odgovorno in v skladu s temi pogoji.
        </p>
        <p>
          Fukodrom je skupnostno usmerjen produkt. To pomeni, da je del vsebine ustvarjen s strani
          uporabnikov in morda ni vedno popoln, ažuren ali primeren za vsako situacijo. Storitev je
          namenjena informiranju in sodelovanju skupnosti, ne pa kot jamstvo za varnost, dostopnost ali
          zakonitost posamezne lokacije v vsakem trenutku.
        </p>
      </section>

      <section id="accounts">
        <h2>Računi, prijava in varnost</h2>
        <p>
          Nekatere funkcije Fukodroma zahtevajo račun. Ob registraciji morate navesti točne podatke,
          zlasti veljaven e-poštni naslov, ki ga lahko uporabljamo za komunikacijo o računu in
          varnosti. Za varovanje dostopa do računa ste odgovorni sami, vključno z izbiro razumnega
          gesla in preprečevanjem nepooblaščene uporabe.
        </p>
        <p>
          Ne smete deliti računa na način, ki bi spodkopal zaupanje v skupnost, ustvarjati lažnih
          identitet za zavajanje drugih ali uporabljati avtomatiziranih računov za spam, manipulacijo
          ocen, izogibanje omejitvam ali drugo zlorabo storitve.
        </p>
      </section>

      <section id="acceptable-use">
        <h2>Dovoljena in nedovoljena uporaba</h2>
        <p>
          Fukodrom lahko uporabljate samo za zakonite, varne in razumno skupnostne namene. Brez naše
          predhodne odobritve ne smete:
        </p>
        <ul>
          <li>objavljati spama, phishinga, zlonamernih povezav ali druge zavajajoče vsebine,</li>
          <li>objavljati osebnih podatkov tretjih oseb, zasebnih naslovov ali doxxing vsebine,</li>
          <li>posredovati navodil za nevaren, nezakonit ali nepooblaščen dostop do lokacij,</li>
          <li>zlorabljati sistemov prijave, moderatorjev ali mehanizmov za poročanje,</li>
          <li>poskušati obiti varnostne ukrepe, omejitve dostopa, rate limite ali zaščite prijave,</li>
          <li>uporabljati storitve na način, ki bi lahko škodoval delovanju platforme ali drugim uporabnikom.</li>
        </ul>
        <p>
          Podrobnejša pravila sprejemljive uporabe so lahko objavljena tudi na ločeni strani, vendar
          ti pogoji veljajo kot osnovni pogodbeni okvir ne glede na to, ali je posamezna kršitev tam
          izrecno navedena.
        </p>
      </section>

      <section id="user-content">
        <h2>Vsebina uporabnikov in dovoljenje za uporabo</h2>
        <p>
          Ob oddaji lokacije, mnenja, komentarja, poročila ali druge vsebine potrjujete, da imate
          pravico tako vsebino objaviti in da njena objava ne krši pravic drugih oseb, zakonodaje ali
          teh pogojev. Odgovorni ste za točnost in zakonitost vsebine, ki jo prispevate.
        </p>
        <p>
          Lastništvo vaše vsebine načeloma ostane vaše. Vendar nam z objavo podelite neizključno,
          svetovno, brezplačno licenco, kolikor je razumno potrebna za gostovanje, prikaz, tehnično
          obdelavo, indeksiranje, moderiranje, promocijo storitve znotraj produkta ter varnostno
          arhiviranje vsebine. Ta licenca traja toliko časa, kolikor je potrebno za delovanje storitve
          in uveljavljanje legitimnih interesov, kot so obramba zahtevkov ali vodenje moderacijskih evidenc.
        </p>
      </section>

      <section id="moderation">
        <h2>Moderiranje, odstranitve in izvrševanje pravil</h2>
        <p>
          Fukodrom si pridržuje pravico, da po lastni razumni presoji pregleda, omeji, skrije,
          uredi ali odstrani vsebino ter opozori, začasno omeji ali ukine račun, če ocenimo, da je to
          potrebno za zaščito skupnosti, skladnost z zakonodajo, odziv na prijave, preprečevanje
          zlorab ali zmanjševanje pravnega in varnostnega tveganja.
        </p>
        <p>
          Nismo dolžni spremljati vsake objave vnaprej, vendar lahko ukrepamo retroaktivno. V nekaterih
          primerih lahko vsebino odstranimo brez predhodnega obvestila, zlasti kadar gre za tveganje za
          varnost, zasebnost, goljufijo, očitno nezakonito vsebino ali ponavljajoče se zlorabe.
        </p>
      </section>

      <section id="availability">
        <h2>Razpoložljivost storitve in spremembe produkta</h2>
        <p>
          Trudimo se, da je Fukodrom zanesljiv in uporaben, vendar storitev ni obljubljena kot vedno
          dosegljiva, brez napak ali popolnoma varna. Posamezne funkcije lahko dodajamo, spreminjamo,
          omejujemo ali ukinjamo; prav tako lahko začasno prekinemo dostop zaradi vzdrževanja,
          nadgradenj, varnostnih razlogov ali zunanjih motenj.
        </p>
        <p>
          Če je to razumno mogoče, bomo bistvene spremembe poskušali napovedati na razumljiv način.
          Vseeno si pridržujemo pravico, da storitev prilagodimo, ker gre za razvijajoč se produkt in
          skupnostno platformo.
        </p>
      </section>

      <section id="liability">
        <h2>Izključitev jamstev in omejitev odgovornosti</h2>
        <p>
          Fukodrom je na voljo na osnovi »kot je« in »kot je na voljo«. V največjem obsegu, ki ga
          dopušča veljavna zakonodaja, ne dajemo jamstev glede neprekinjene dosegljivosti, natančnosti,
          primernosti za določen namen ali popolne varnosti posamezne lokacije, ocene ali objave.
        </p>
        <p>
          Pred obiskom lokacije morate sami preveriti dostopnost terena, varnost, vreme, lokalna
          pravila, zasebnost prostora, požarno ogroženost in druge okoliščine. Fukodrom ni organizator
          obiskov in ne prevzema odgovornosti za ravnanje uporabnikov na terenu.
        </p>
        <p>
          V največjem obsegu, ki ga dopušča pravo, Fukodrom ne odgovarja za posredno škodo, izgubo
          podatkov, izgubo dobička, izgubo poslovne priložnosti, škodo zaradi ravnanja drugih uporabnikov
          ali posledice zanašanja na skupnostno vsebino. Nič v teh pogojih ne izključuje odgovornosti,
          ki je po zakonu ni mogoče izključiti.
        </p>
      </section>

      <section id="changes">
        <h2>Spremembe teh pogojev</h2>
        <p>
          Te pogoje lahko občasno posodobimo, če se spremeni storitev, zakonodaja ali način delovanja
          skupnosti. Posodobljena različica začne veljati z objavo na tej strani, razen če izrecno
          navedemo drugače. Če bodo spremembe bistvene, si bomo prizadevali uporabnike o tem obvestiti
          opazneje, na primer v aplikaciji ali po e-pošti, kadar je to primerno.
        </p>
        <p>
          Nadaljnja uporaba Fukodroma po začetku veljavnosti posodobljenih pogojev pomeni, da sprejemate
          novo različico v obsegu, ki ga dopušča pravo. Če se s spremembami ne strinjate, prenehajte
          uporabljati storitev in po potrebi zahtevajte zaprtje računa.
        </p>
      </section>

      <section id="law">
        <h2>Pravo, pristojnost in kontakt</h2>
        <p>
          Če ni obveznih pravil, ki določajo drugače, se ti pogoji razlagajo po pravu jurisdikcije,
          v kateri je upravljavec Fukodroma običajno ustanovljen ali posluje. Konkretna določitev
          pristojnega prava in sodišča se lahko dopolni, ko bo organizacijska struktura storitve
          dokončno formalizirana.
        </p>
        <p>
          Za splošna vprašanja o teh pogojih, prijave zlorab ali pravne zahteve nam pišite na{' '}
          <a href="mailto:privacy@fukodrom.com">privacy@fukodrom.com</a>. Za vprašanja o obdelavi
          osebnih podatkov velja tudi naša Politika zasebnosti.
        </p>
      </section>
    </StaticPage>
  )
}
